module.exports = __webpack_public_path__ + "img/pump.ea899897.png";